import "./navbar.css";
import { Link } from "react-router-dom";

import logo from "../img/logo.png";


export default function Nav() {
  return (
    <nav className="navbar">
      <div className="nav-left">
        <a href="/voditelj">Voditelj</a>
        <a href="/lokacija">Lokacija</a>
      </div>

       <Link className="navbar-brand" to="/">
      <img src={logo} alt="Logo" width={100} className="logo-1" />
    </Link>

      <div className="nav-right">
        <a href="/prijava">Prijava</a>
        <a href="/galerija">Galerija</a>
      </div>
    </nav>
  );
}